module.exports = __webpack_public_path__ + "img/card-96D5FF.b59d5445.png";